export default function () {
    return {
        buttonDisabled: false,
        showAskQuestionForm: false,
        showQuestionsItems: 3,
        isShowAllQuestions: false,
        customerEmail: '',
        customerName: '',
        formValid: false,
        init() {
            window.require(
                ['Magento_Customer/js/customer-data'],
                (customerData) => {
                    const customer = customerData.get('faq')();
                    this.customerEmail = customer.email || '';
                    this.customerName = customer.name || '';
                }
            );
        },
        submitForm(event) {
            if (this.formValid) {
                this.buttonDisabled = true;
            } else {
                event.preventDefault();
                this.buttonDisabled = false;
            }
        },
        buttonShowMoreIsVisibility(items) {
            return Number(items) > Number(this.showQuestionsItems);
        },
        questionsVisibility(item) {
            if (this.isShowAllQuestions) {
                return true;
            }
            return item <= this.showQuestionsItems;
        }
    };
}
